import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, Lock } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger } from "./ui/sheet";
import { Button } from "./ui/button";

const LINKS = [
  { href: "#chi-sono", label: "Chi Sono", testid: "nav-link-chi-sono" },
  { href: "#servizi", label: "Servizi", testid: "nav-link-servizi" },
  { href: "#prenota", label: "Prenota", testid: "nav-link-prenota" },
  { href: "#prima-sessione", label: "Prima Sessione", testid: "nav-link-prima-sessione" },
  { href: "#safeguarding", label: "Safeguarding", testid: "nav-link-safeguarding" },
  { href: "#contatti", label: "Contatti", testid: "nav-link-contatti" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#08090C]/80 border-b border-white/10 shadow-2xl shadow-black/50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-28 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-2 group">
          <img src="/logo.png" alt="Personal and Team Coach"
               className="h-24 w-24 rounded-2xl object-cover ring-1 ring-white/10 group-hover:ring-orange-400/60 group-hover:shadow-[0_0_20px_rgba(251,146,60,0.4)] transition-all" />
        </a>
        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} data-testid={l.testid}
               className="text-sm font-medium text-slate-300 hover:text-sky-400 transition-colors">
              {l.label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <Link to="/admin" data-testid="nav-btn-admin-login">
            <Button variant="outline" size="sm"
              className="border-sky-500/40 text-sky-400 hover:bg-sky-500/10 hover:text-sky-300 bg-transparent">
              <Lock className="w-4 h-4 mr-2" /> Area Riservata
            </Button>
          </Link>
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild className="lg:hidden">
              <Button variant="ghost" size="icon" data-testid="nav-mobile-menu-btn" className="text-white">
                <Menu className="w-6 h-6" />
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="bg-[#10141D]/95 backdrop-blur-xl border-[#222A3B]">
              <nav className="flex flex-col gap-6 mt-10">
                {LINKS.map((l) => (
                  <a key={l.href} href={l.href} data-testid={`mobile-${l.testid}`} onClick={() => setOpen(false)}
                     className="text-lg font-medium text-slate-200 hover:text-sky-400 transition-colors">
                    {l.label}
                  </a>
                ))}
              </nav>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};
